import ExcelJS from "exceljs";

export const downloadInventoryCountExcel = async ({
    receipt,
    statusLabel,
}) => {
    const workbook = new ExcelJS.Workbook();

    workbook.creator = "NetLedger";
    workbook.created = new Date();

    const worksheet = workbook.addWorksheet(
        "Conteo físico",
        {
            views: [
                {
                    showGridLines: false,
                },
            ],
            pageSetup: {
                orientation: "landscape",
                fitToPage: true,
                fitToWidth: 1,
                fitToHeight: 0,
                margins: {
                    left: 0.25,
                    right: 0.25,
                    top: 0.35,
                    bottom: 0.35,
                    header: 0.2,
                    footer: 0.2,
                },
            },
        }
    );

    const colors = {
        primary: "FFE600A9",
        navy: "FF1B3151",
        muted: "FF425976",
        border: "FFDCE6F0",
        light: "FFF4F7FB",
        alternate: "FFF8FBFF",
        success: "FF078B59",
        danger: "FFC32929",
        white: "FFFFFFFF",
    };

    const integerFormat = "#,##0;[Red]-#,##0";
    const currencyFormat =
        '"$"#,##0.00;[Red]-"$"#,##0.00';

    const numberValue = (value) => Number(value || 0);

    const border = {
        top: {
            style: "thin",
            color: { argb: colors.border },
        },
        bottom: {
            style: "thin",
            color: { argb: colors.border },
        },
        left: {
            style: "thin",
            color: { argb: colors.border },
        },
        right: {
            style: "thin",
            color: { argb: colors.border },
        },
    };

    const items = Array.isArray(receipt.items)
        ? receipt.items
        : [];

    worksheet.columns = [
        { key: "sku", width: 22 },
        { key: "product", width: 32 },
        { key: "initial", width: 19 },
        { key: "physical", width: 19 },
        { key: "closing", width: 19 },
        { key: "adjustment", width: 19 },
        { key: "cost", width: 18 },
        { key: "notes", width: 28 },
    ];

    worksheet.mergeCells("B1:H1");

    const logoContainer = worksheet.getCell("A1");

    const titleCell = worksheet.getCell("B1");

    titleCell.value = "COMPROBANTE DE CONTEO FÍSICO";
    titleCell.font = {
        name: "Arial",
        size: 18,
        bold: true,
        color: { argb: colors.white },
    };
    titleCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: colors.primary },
    };
    titleCell.alignment = {
        horizontal: "center",
        vertical: "middle",
    };
    titleCell.border = border;

    worksheet.getRow(1).height = 82;

    const logoBase64 =
        receipt.company?.logo_data_url || null;

    if (logoBase64) {
        const logoId = workbook.addImage({
            base64: logoBase64,
            extension: logoBase64.includes("image/png")
                ? "png"
                : "jpeg",
        });

        worksheet.addImage(logoId, {
            tl: { col: 0.1, row: 0.14 },
            ext: { width: 155, height: 67 },
        });
    } else {
        logoContainer.value = "NETLEDGER";
        logoContainer.font = {
            name: "Arial",
            size: 11,
            bold: true,
            color: { argb: colors.muted },
        };
        logoContainer.alignment = {
            horizontal: "center",
            vertical: "middle",
        };
    }

    const informationRows = [
        ["Empresa", receipt.company?.company_name || ""],
        ["NIT", receipt.company?.nit || ""],
        ["Conteo", receipt.count_number || ""],
        ["Estado", statusLabel(receipt.status)],
        ["Bodega", receipt.warehouse?.name || ""],
        [
            "Fecha de conteo",
            receipt.count_date
                ? new Date(`${receipt.count_date}T00:00:00`)
                : "",
        ],
        [
            "Fecha de aprobación",
            receipt.approved_at || receipt.completed_at
                ? new Date(
                    receipt.approved_at || receipt.completed_at
                )
                : "",
        ],
        [
            "Creado por",
            receipt.created_by?.name || "No disponible",
        ],
        [
            "Aprobado por",
            receipt.approved_by?.name ||
            receipt.completed_by?.name ||
            "No disponible",
        ],
        [
            "Observaciones",
            receipt.notes || "Sin observaciones",
        ],
    ];

    informationRows.forEach((item, index) => {
        const rowNumber = index + 3;

        worksheet.mergeCells(`B${rowNumber}:H${rowNumber}`);

        const labelCell = worksheet.getCell(`A${rowNumber}`);
        const valueCell = worksheet.getCell(`B${rowNumber}`);

        labelCell.value = item[0];
        valueCell.value = item[1];

        worksheet.getRow(rowNumber).height = 22;

        labelCell.font = {
            name: "Arial",
            size: 10,
            bold: true,
            color: { argb: colors.muted },
        };
        labelCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: colors.light },
        };
        labelCell.alignment = {
            horizontal: "left",
            vertical: "middle",
        };
        labelCell.border = border;

        valueCell.font = {
            name: "Arial",
            size: 10,
            color: { argb: colors.navy },
        };
        valueCell.alignment = {
            horizontal: "left",
            vertical: "middle",
            wrapText: true,
        };
        valueCell.border = border;
    });

    worksheet.getCell("B8").numFmt = "dd/mm/yyyy";
    worksheet.getCell("B9").numFmt =
        "dd/mm/yyyy h:mm AM/PM";

    worksheet.mergeCells("A14:H14");

    const detailTitle = worksheet.getCell("A14");

    detailTitle.value = "DETALLE DEL CONTEO";
    detailTitle.font = {
        name: "Arial",
        size: 11,
        bold: true,
        color: { argb: colors.primary },
    };
    detailTitle.alignment = {
        vertical: "middle",
    };

    worksheet.getRow(14).height = 22;

    const headerRow = worksheet.getRow(15);

    headerRow.values = [
        "Código",
        "Producto",
        "Teórico inicial",
        "Cantidad física",
        "Teórico al cierre",
        "Ajuste aplicado",
        "Costo unitario",
        "Observaciones",
    ];

    headerRow.height = 27;

    headerRow.eachCell((cell) => {
        cell.font = {
            name: "Arial",
            size: 10,
            bold: true,
            color: { argb: colors.white },
        };
        cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: colors.primary },
        };
        cell.alignment = {
            horizontal: "center",
            vertical: "middle",
            wrapText: true,
        };
    });

    const firstDetailRow = 16;

    items.forEach((item, index) => {
        const rowNumber = firstDetailRow + index;
        const row = worksheet.getRow(rowNumber);

        row.values = [
            item.product_sku || "",
            item.product_name || "",
            numberValue(item.system_quantity_at_start),
            numberValue(item.counted_quantity),
            numberValue(item.system_quantity_at_close),
            numberValue(item.adjustment_quantity),
            numberValue(item.unit_cost),
            item.notes || "",
        ];

        row.height = 23;

        row.eachCell((cell) => {
            cell.font = {
                name: "Arial",
                size: 10,
                color: { argb: colors.muted },
            };
            cell.alignment = {
                vertical: "middle",
                wrapText: true,
            };
            cell.border = {
                bottom: {
                    style: "thin",
                    color: { argb: "FFE1E9F1" },
                },
            };
        });

        if (index % 2 === 0) {
            row.eachCell((cell) => {
                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: colors.alternate },
                };
            });
        }

        ["C", "D", "E", "F"].forEach((column) => {
            worksheet.getCell(
                `${column}${rowNumber}`
            ).numFmt = integerFormat;
        });

        worksheet.getCell(
            `G${rowNumber}`
        ).numFmt = currencyFormat;

        const adjustmentCell = worksheet.getCell(
            `F${rowNumber}`
        );

        if (numberValue(item.adjustment_quantity) > 0) {
            adjustmentCell.font = {
                name: "Arial",
                size: 10,
                bold: true,
                color: { argb: colors.success },
            };
        }

        if (numberValue(item.adjustment_quantity) < 0) {
            adjustmentCell.font = {
                name: "Arial",
                size: 10,
                bold: true,
                color: { argb: colors.danger },
            };
        }
    });

    const lastDetailRow =
        items.length > 0
            ? firstDetailRow + items.length - 1
            : 15;

    worksheet.autoFilter = {
        from: {
            row: 15,
            column: 1,
        },
        to: {
            row: Math.max(lastDetailRow, 15),
            column: 8,
        },
    };

    const summaryStartRow = lastDetailRow + 3;

    const summaryRows = [
        [
            "Productos contados",
            numberValue(receipt.summary?.counted_items),
        ],
        [
            "Productos con diferencia",
            numberValue(
                receipt.summary?.items_with_difference
            ),
        ],
        [
            "Ajuste neto de unidades",
            items.length > 0
                ? {
                    formula: `SUM(F${firstDetailRow}:F${lastDetailRow})`,
                }
                : 0,
        ],
    ];

    summaryRows.forEach((item, index) => {
        const rowNumber = summaryStartRow + index;
        const labelCell = worksheet.getCell(`A${rowNumber}`);
        const valueCell = worksheet.getCell(`B${rowNumber}`);

        labelCell.value = item[0];
        valueCell.value = item[1];

        labelCell.font = {
            name: "Arial",
            size: 10,
            bold: true,
            color: { argb: colors.muted },
        };
        labelCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: colors.light },
        };
        labelCell.border = border;

        valueCell.font = {
            name: "Arial",
            size: 10,
            bold: true,
            color: {
                argb:
                    index === 2 ? colors.primary : colors.navy,
            },
        };
        valueCell.numFmt = integerFormat;
        valueCell.border = border;
    });

    worksheet.headerFooter.oddFooter =
        "&CComprobante de conteo físico · Generado por NetLedger";

    const excelBuffer = await workbook.xlsx.writeBuffer();

    const file = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const fileUrl = window.URL.createObjectURL(file);
    const link = document.createElement("a");

    link.href = fileUrl;
    link.download = `Conteo_${receipt.count_number}.xlsx`;

    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(fileUrl);
};